import { JSONClient } from "./bootstrap";
import store from "../store";

export const speedsChart = async (stype, startData, endDate) => {
  try {
    const response = await JSONClient.post(
      "/history/getTaskSolveSpeedChart",
      {
        filter: stype.toUpperCase(),
        startTime: new Date(startData).getTime(),
        endTime: new Date(endDate).getTime(),
        // points: 10
      },
      {
        headers: {
          Authorization:
            `Bearer ${store.getters["userStore/getAuthToken"]}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const activityG = async (filter, startData, endDate) => {
  try {
    const response = await JSONClient.post(
      "/history/getTaskActivityHistoryChart",
      {
        filter: filter.toUpperCase(),
        startTime: new Date(startData).getTime(),
        endTime: new Date(endDate).getTime(),
        // points: 10
      },
      {
        headers: {
          Authorization:
            `Bearer ${store.getters["userStore/getAuthToken"]}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const spendingG = async (filter, startData, endDate) => {
  try {
    const response = await JSONClient.post(
      "/history/getUserSpendingChart",
      {
        filter: filter.toUpperCase(),
        startTime: new Date(startData).getTime(),
        endTime: new Date(endDate).getTime(),
        // points: 10
      },
      {
        headers: {
          Authorization:
            `Bearer ${store.getters["userStore/getAuthToken"]}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const systemStats = async (type) => {
  try {
    const response = await JSONClient.post(
      "/captcha/avg-data",
      {
        queue: type.toUpperCase(),
      },
      {
        headers: {
          Authorization:
            `Bearer ${store.getters["userStore/getAuthToken"]}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const avgSpeed = async (type, startDate, endDate, queueType) => {
  try {
    const response = await JSONClient.post(
      "/captcha/chart/avg-speed",
      {
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
        filter: type.toUpperCase(),
        queueType: queueType
      },
      {
        headers: {
          Authorization:
            `Bearer ${store.getters["userStore/getAuthToken"]}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    // console.log(e);
  }
};

export const avgFactorySpeed = async (type, startDate, endDate) => {
  try {
    const response = await JSONClient.post(
      "/factories/chart/avg-speed",
      {
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
        filter: type.toUpperCase(),
      },
      {
        headers: {
          Authorization:
            `Bearer ${store.getters["userStore/getAuthToken"]}`,
        },
      }
    );
    return response.data;
  } catch (e) {
    // console.log(e)
  }
};

export const fetchStats = async (metric) => {
  try {
    const response = await JSONClient.post('/stats/getPublicStats', {
      metric
    })
    return response.data;
  } catch (error) {
    // console.log(error)
  }
}